"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretUp = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const caret_down_1 = require("./caret-down");
const CaretUp = ({ fill = "none" }) => {
    const caretUpStyles = {
        display: "flex",
        transform: "rotate(180deg)",
        transformOrigin: "center"
    };
    if (fill === "filled") {
        return (react_1.default.createElement(__1.Box, { as: "span", sx: caretUpStyles },
            react_1.default.createElement(caret_down_1.CaretDown, { fill: "filled" })));
    }
    return (react_1.default.createElement(__1.Box, { as: "span", sx: caretUpStyles },
        react_1.default.createElement(caret_down_1.CaretDown, null)));
};
exports.CaretUp = CaretUp;
//# sourceMappingURL=caret-up.js.map